import { Link } from 'react-router-dom';
import { seoArticles } from '@/mocks/articles';

export default function SEOArticleSection() {
  const article = seoArticles[0];

  return (
    <section className="relative bg-gradient-to-b from-[#3d2e1e] via-[#2e2216] to-[#1f1610] py-20 md:py-28 overflow-hidden">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-3">
          <span className="inline-block bg-accent-100/20 text-accent-200 text-xs font-label font-bold px-3 py-1.5 rounded-full">
            / Artykuły SEO
          </span>
        </div>

        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white max-w-[680px] leading-tight">
          Kakobuy Sheet — Kompletny Przewodnik po Zakupach
        </h2>

        <p className="mt-6 text-white/60 text-base md:text-lg max-w-[560px] leading-relaxed">
          Dowiedz się, jak efektywnie korzystać z arkusza zakupowego Kakobuy Spreadsheet. Poznaj wszystkie kategorie produktów, porównaj alternatywy i odkryj najlepsze praktyki zakupowe, które zaoszczędzą Twój czas i pieniądze.
        </p>

        <div className="mt-14 flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-[320px] shrink-0">
            <img
              src="https://readdy.ai/api/search-image?query=A%20modern%20tablet%20device%20displaying%20a%20colorful%20product%20spreadsheet%20grid%20resting%20on%20a%20textured%20wool%20blanket%2C%20surrounded%20by%20small%20curated%20fashion%20items%20including%20a%20miniature%20sneaker%20keychain%20and%20a%20leather%20cardholder%2C%20soft%20window%20light%20from%20above%2C%20cozy%20scandinavian%20living%20room%20corner%20with%20a%20ceramic%20mug%20nearby%2C%20editorial%20lifestyle%20photography%2C%20warm%20neutral%20palette%2C%20no%20text&width=640&height=640&seq=article-preview-kakobuy-v2&orientation=squarish"
              alt="Kakobuy Spreadsheet — Przewodnik po arkuszu zakupowym"
              title="Kakobuy Spreadsheet — artykuł SEO"
              className="w-full rounded-lg object-cover"
            />
          </div>

          <div className="flex-1">
            <div className="text-accent-200 font-heading text-7xl md:text-8xl font-bold leading-none">01</div>
            <p className="mt-4 text-white/70 text-base leading-relaxed max-w-[480px]">
              {article.excerpt}
            </p>
            <Link
              to={`/artykul/${article.slug}`}
              className="inline-flex items-center gap-2 mt-8 px-7 py-3.5 bg-white text-foreground-900 font-label font-bold text-sm rounded-full whitespace-nowrap cursor-pointer hover:bg-background-100 transition-all"
            >
              Przeczytaj Poradnik
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}